import "./ClientCasesListScreen.scss";
import {useCallback, useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import SelectDropdownComponent from "../../../shared/components/form-controls/select-dropdown/SelectDropdownComponent";
import {CommonService} from "../../../shared/services";
import moment from "moment/moment";
import TableWrapperComponent from "../../../shared/components/table-wrapper/TableWrapperComponent";
import {APIConfig, ImageConfig} from "../../../constants";
import CardComponent from "../../../shared/components/card/CardComponent";
import {ITableColumn} from "../../../shared/models/table.model";
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import LinkComponent from "../../../shared/components/link/LinkComponent";
import {getCaseStatusList} from "../../../store/actions/static-data.action";
import ToolTipComponent from "../../../shared/components/tool-tip/ToolTipComponent";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import momentTimezone from "moment-timezone";
import {useNavigate} from "react-router-dom";
import DateRangePickerComponentV2 from "../../../shared/components/date-range-pickerV2/DateRangePickerComponentV2";

interface ClientCasesListComponentProps {

}

const ClientCasesListScreen = (props: ClientCasesListComponentProps) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [casesFilterData, setCasesFilterData] = useState<any>({
        service_id: undefined,
        status: undefined,
        date_range: [null, null],
        start_date: null,
        end_date: null,
        timezone: momentTimezone.tz.guess(),
        sort: {}
    });
    const {
        serviceList,
        isServiceListLoaded,
        isServiceListLoading,
    } = useSelector((state: IRootReducerState) => state.client);

    useEffect(() => {
        dispatch(getCaseStatusList())
    }, [dispatch]);


    const columns: ITableColumn[] = useMemo<ITableColumn[]>(() => [
        {
            title: "Case Name",
            key: "case_name",
            dataIndex: "case_name",
            width: 390,
            render: (record: any) => {
                return (
                    <>
                        {record?.record_type === 'medical_record'
                            && <ToolTipComponent
                                tooltip={<>{record?.created_at && CommonService.convertDateFormat2(record?.created_at)}{' '}{record?.injury_details?.map((injury: any, index: number) => {
                                    return <>{injury?.body_part_name} {injury?.body_side ? `(${injury?.body_side})` : ''}{index !== record?.injury_details.length - 1 ?<>, </> : ""}</>
                                })}</>} position={'bottom'}>
                                <div className={'medical-record-injury-details'} ref={record}>
                                    {record?.created_at && CommonService.convertDateFormat2(record?.created_at)}{" "}
                                    {"-"} {record?.injury_details?.map((injury: any, index: number) => {
                                    return <>{injury?.body_part_name} {injury?.body_side ? `(${injury?.body_side})` : ''}{index !== record?.injury_details.length - 1 ?<>, </> : ""}</>
                                })}
                                </div>
                            </ToolTipComponent>
                        }
                        {
                            record?.record_type === 'performance_record' &&
                            <ToolTipComponent
                                tooltip={<>
                                    <div>{record?.created_at && CommonService.convertDateFormat2(record?.created_at)}</div>
                                    <div>{record?.program_focus}</div>
                                </>}
                                position={"top"}
                                showArrow={true}
                            >
                                <div className={'performance-record-date'}>
                                    {record?.created_at && CommonService.convertDateFormat2(record?.created_at)} - {record?.program_focus}
                                </div>
                            </ToolTipComponent>
                        }
                    </>
                )
            }
        },
        {
            title: "Service Name",
            key: "service",
            dataIndex: "service_name",
            align: "center",
            width: 280,
            render: (record: any) => {
                return (<>

                        <ToolTipComponent
                            tooltip={<>
                                <div>{record?.category_details?.name}</div>
                                <div>{record?.service_details?.name}</div>
                            </>}
                            position={"top"}
                            showArrow={true}
                        >
                            <div className={"ellipses-for-table-data"}>
                                {CommonService.getFirstLetterOfEachWord(record?.category_details?.name) + " - " + record?.service_details?.name}
                            </div>
                        </ToolTipComponent>
                    </>
                )
            }
        },
        {
            title: "Provider Name",
            key: "provider",
            dataIndex: "provider",
            align: "center",
            sortable: true,
            width: 201,
            render: (record: any) => {
                return (
                    <span>{record?.provider}</span>
                );
            }
        },
        {
            title: "Status",
            key: "status",
            dataIndex: "status",
            align: "center",
            sortable: true,
            width: 189,
            render: (record: any) => {
                return (
                    <ChipComponent label={record?.status_details?.code}
                                   className={record?.status_details?.title === "Open - Unresolved" ? "open" : "close"}/>
                );
            }
        },

        {
            title: "Action",
            key: "view_details",
            dataIndex: "view_details",
            align: "center",
            fixed: "right",
            // width: 25,
            render: (record: any) => {
                return (<>
                        {
                            record?.record_type === 'medical_record' &&
                            <LinkComponent route={CommonService._routeConfig.CaseDetails(record._id)}>
                                View Details
                            </LinkComponent>
                        }
                        {
                            record?.record_type === 'performance_record' &&
                            <LinkComponent route={CommonService._routeConfig.PerformanceRecordViewDetails(record._id)}>
                                View Details
                            </LinkComponent>
                        }
                    </>
                )
            }
        },
    ], []);


    const handleSort = useCallback((key: string, order: string) => {
        setCasesFilterData((oldState: any) => {
            const newState = {...oldState};
            newState["sort"] = {
                key,
                order
            }
            return newState;
        })
    }, []);

    return (
        <div className="case-screen list-screen">
            <div className="list-screen__header">
                <div className="list-screen__header-title">
                    My Cases
                </div>
                <div className={'d-flex'}>
                    <ButtonComponent className={'mrg-left-20'} color={'accent'}
                                     onClick={() => {
                                         navigate(CommonService._routeConfig.OtherSharedDocuments())
                                     }}
                                     variant={'outlined'} prefixIcon={<ImageConfig.EyeIcon/>}>
                        View Other Documents
                    </ButtonComponent>
                </div>
            </div>
            <CardComponent className={'case-list-filters-container-card'}>
                <div>
                    <div className="case-list-filters mrg-0  ts-row">
                        <div className="ts-col-lg-3 ts-col-md-12 ">
                            <SelectDropdownComponent
                                size={"small"}
                                placeholder={"Service"}
                                options={serviceList}
                                value={casesFilterData?.service_id}
                                displayWith={(option: any) => option.name}
                                valueExtractor={(option: any) => option._id}
                                isDataLoading={isServiceListLoading}
                                isDataLoaded={isServiceListLoaded}
                                onUpdate={(value: any) => {
                                    setCasesFilterData({
                                        ...casesFilterData,
                                        service_id: value
                                    });
                                }}
                            />
                        </div>

                        <div className="ts-col-lg-6"/>
                        <div className={'ts-col-lg-3 ts-col-md-12 pdd-right-10 '}>
                            <DateRangePickerComponentV2
                                value={casesFilterData.date_range}
                                onDateChange={(value: any) => {
                                    setCasesFilterData((prevState: any) => {
                                        if (value) {
                                            return {
                                                ...prevState,
                                                start_date: moment(value[0]).format('YYYY-MM-DD'),
                                                end_date: moment(value[1]).format('YYYY-MM-DD'),
                                                date_range: value,
                                                timezone: momentTimezone.tz.guess()
                                            };
                                        } else {
                                            const {date_range, start_date, end_date, ...rest} = prevState;
                                            return rest;
                                        }
                                    });
                                }}
                            />
                        </div>
                    </div>
                    <div className={'ts-col-lg-12'}>
                        <TableWrapperComponent
                            columns={columns}
                            method={APIConfig.GET_CASES_LIST.METHOD}
                            url={APIConfig.GET_CASES_LIST.URL}
                            onSort={handleSort}
                            noDataText={(casesFilterData?.service_id || casesFilterData?.status ||
                                casesFilterData?.start_date || casesFilterData?.end_date) ? 'No case was found for the applied filter.' : 'No cases have been added.'}
                            extraPayload={casesFilterData}
                        />
                    </div>
                </div>
            </CardComponent>
        </div>
    )
        ;

};

export default ClientCasesListScreen;
